import { render, staticRenderFns } from "./Helix.vue?vue&type=template&id=1414b974&scoped=true&"
import script from "./Helix.vue?vue&type=script&lang=js&"
export * from "./Helix.vue?vue&type=script&lang=js&"
import style0 from "./Helix.vue?vue&type=style&index=0&id=1414b974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1414b974",
  null
  
)

export default component.exports